import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};

export function ShareableEmailTemplatesFeatureGate(props: Props) {
    return (
        <FeatureGateModalWrapper
            title='Create and share email templates with your team'
            description='Save time by creating email templates that your team can easily use.'
            bullets={[
                "Create custom email templates that reflect your company's style and messaging",
                'Align templates with team goals',
                'Share templates for quick access to ready-to-use emails.',
            ]}
            feature='shareableEmailTemplates'
            isOpen={props.isOpen}
            onClose={props.onClose}
        />
    );
}
